module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.data,
    attrs: {
      "id": "hailey",
      "width": "160px",
      "height": "454px",
      "viewBox": "0 0 160 454"
    }
  }, [_c('path', {
    attrs: {
      "d": "M49.4033203,143.128906 L128.939453,143.128906 C128.939453,105.009115 128.939453,78.2955729 128.939453,62.9882812 C128.939453,50.2676981 134.398438,15.34375 99.4355469,14.84375 C56.0579713,14.2234126 49.8476562,31.6884766 49.4033203,54.5429687 C49.1070964,69.7792969 49.1070964,99.3079427 49.4033203,143.128906 Z",
      "id": "hailey_hair",
      "fill": "#DD9B2E"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "hailey_bag_3",
      "fill": "#333333",
      "x": "80",
      "y": "109.266659",
      "width": "57.5136719",
      "height": "80.8124422",
      "rx": "15"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "hailey_right_arm"
    }
  }, [_c('g', {
    attrs: {
      "id": "hailey_right_arm_hand"
    }
  }, [_c('path', {
    attrs: {
      "d": "M33.8406269,233.461736 C33.3689481,236.312668 31.1861354,237.598003 28.7856655,240.670045 C25.9849108,244.254359 25.1273721,251.33569 21.7703409,256.907 C22.2519037,258.385133 26.8228758,256.464596 28.0484579,254.206606 C29.27404,251.948616 30.223873,250.106488 30.6136357,249.547873 C31.0033984,248.989258 31.729072,249.146793 31.8626122,249.753679 C31.9961523,250.360565 29.2801629,271.228279 29.5789778,272.319282 C29.8777927,273.410284 32.4176275,273.849651 33.0233322,272.864814 C33.6290369,271.879977 36.1731032,255.431832 36.4576515,255.025884 C36.7421997,254.619935 37.2682008,254.920323 37.4682727,255.18595 C37.6683446,255.451578 34.4796192,272.947436 34.7562023,273.661111 C35.0327853,274.374786 37.6796474,274.677926 38.0495723,274.182729 C38.4194972,273.687533 41.289528,256.19853 41.6383261,255.846422 C41.9871243,255.494314 42.5592867,255.630552 42.7403622,256.020967 C42.9214377,256.411383 39.6050608,273.16497 39.9000521,273.953979 C40.1950434,274.742988 42.7421718,275.158129 43.093203,274.459725 C43.4442342,273.761321 46.6494371,256.892503 46.9353299,256.685385 C47.2212228,256.478267 47.5497034,256.5539 47.749634,256.814358 C47.9495646,257.074816 46.1932615,269.774952 46.4909599,270.52747 C46.7886583,271.279989 48.6919848,271.748115 49.111082,270.942457 C49.5301791,270.136799 53.0586979,239.058213 53.3678369,237.35143 C54.3980633,231.663463 52.0057945,225.173026 45.3115885,224.112768 C38.6173825,223.05251 34.853518,227.339596 33.8406269,233.461736 Z",
      "id": "hailey_right_hand",
      "fill": "#DBBFAF"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.0135371,174.709381 C58.4683892,175.573344 62.1900395,180.695757 61.3260758,186.150609 L53.5043526,235.535026 L33.7505858,232.406337 L41.572309,183.02192 C42.4362727,177.567067 47.558685,173.845417 53.0135371,174.709381 Z",
      "id": "hailey_right_arm_bottom",
      "fill": "#6592C7"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M62.8689084,112.485015 C68.3237605,113.348979 72.0454108,118.471391 71.1814471,123.926243 L61.3260758,186.150609 C60.4621122,191.605461 55.3396999,195.327111 49.8848478,194.463148 C44.4299957,193.599184 40.7083453,188.476772 41.572309,183.02192 L51.4276803,120.797554 C52.291644,115.342702 57.4140563,111.621052 62.8689084,112.485015 Z",
      "id": "hailey_right_arm_top",
      "fill": "#6592C7"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M53.1123047,394 L78.1123047,394 L78.1123047,445 L65.7265625,445 C65.7265625,443.064453 64.679362,442.08431 62.5849609,442.05957 C60.4905599,442.034831 59.4573568,443.014974 59.4853516,445 L26,445 C26.6666667,437.279297 28.9814453,432.511719 32.9443359,430.697266 C43.7900031,425.731457 49.8085938,419.831543 51.1054688,414.983887 C52.069372,411.380863 52.7383173,404.386234 53.1123047,394 Z",
      "id": "hailey_right_shoe",
      "fill": "#633C09"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M65.5,310.480469 L65.5,310.480469 L65.5,310.480469 C72.4035594,310.480469 78,316.076909 78,322.980469 L78,394.480469 L53,394.480469 L53,322.980469 L53,322.980469 C53,316.076909 58.5964406,310.480469 65.5,310.480469 Z",
      "id": "hailey_right_leg_bottom",
      "fill": "#CAA792"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "hailey_right_leg_top",
      "fill": "#CAA792",
      "x": "53",
      "y": "225.480469",
      "width": "25",
      "height": "110",
      "rx": "12.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M94.1123047,394 L119.112305,394 L119.112305,445 L106.726562,445 C106.726562,443.064453 105.679362,442.08431 103.584961,442.05957 C101.49056,442.034831 100.457357,443.014974 100.485352,445 L67,445 C67.6666667,437.279297 69.9814453,432.511719 73.9443359,430.697266 C84.7900031,425.731457 90.8085938,419.831543 92.1054688,414.983887 C93.069372,411.380863 93.7383173,404.386234 94.1123047,394 Z",
      "id": "hailey_left_shoe",
      "fill": "#73450A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M106.5,310.480469 L106.5,310.480469 L106.5,310.480469 C113.403559,310.480469 119,316.076909 119,322.980469 L119,394.480469 L94,394.480469 L94,322.980469 L94,322.980469 C94,316.076909 99.5964406,310.480469 106.5,310.480469 Z",
      "id": "hailey_left_leg_bottom",
      "fill": "#CAA792"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "hailey_left_leg_top",
      "fill": "#CAA792",
      "x": "94",
      "y": "225.480469",
      "width": "25",
      "height": "110",
      "rx": "12.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M57.7402344,185.480469 C45.4104818,226.651367 39.163737,248.307943 39,250.450195 C41.1606121,254.242231 45.6138855,257.283854 51.4587548,259.574197 C51.7382861,259.376376 52.4578513,258.51359 53.6174504,256.98584 C53.4711163,258.884033 53.4711163,260.010383 53.6174504,260.364889 C57.9008437,261.831068 62.8038435,262.934564 68.0242785,263.675087 C68.2452348,263.39959 68.7721354,262.29619 69.6049805,260.364889 C69.9443359,262.250617 70.2391211,263.460699 70.4893358,263.995135 C74.8788796,264.513468 79.4529876,264.783926 84.0411662,264.806345 C84.2540378,264.424869 84.7512207,263.15918 85.5327148,261.009277 C86.0576986,263.195475 86.4511295,264.456172 86.7130077,264.791367 C90.8746798,264.724351 95.0206971,264.453154 99.0237491,263.977656 C99.2106345,263.628538 99.4471842,262.40463 99.7333984,260.305931 C100.654134,262.21477 101.291395,263.324106 101.645183,263.63394 C106.862246,262.884057 111.778586,261.774816 116.097269,260.305931 C116.216912,259.939786 116.216912,258.833089 116.097269,256.98584 C117.162306,258.317546 117.942875,259.139133 118.438976,259.450603 C124.240453,257.175686 128.726285,254.175823 131.046875,250.450195 C130.926432,247.96224 124.92041,226.305664 113.028809,185.480469 L57.7402344,185.480469 Z",
      "id": "hailey_skirt",
      "fill": "#333333"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M86,109.600586 C92.3849312,109.600586 111.320801,110.777344 116.598145,112.420898 C115.539063,126.746094 113.251574,146.038133 111.039063,163.055664 C110.797852,173.714844 111.039063,179.00293 113.714844,186.225586 C104.918251,188.877909 68.1216402,187.769272 58.0146484,186.225586 C59.171875,178.011719 59.335693,175.25803 58.0146484,161.621094 C46.2080078,150.47168 58.0146484,132.192383 56.3461914,113.874512 C63.2182617,110.037624 79.6150688,109.600586 86,109.600586 Z",
      "id": "hailey_top_3",
      "fill": "#F9F8F2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M86,109.600586 C92.3849312,109.600586 114.968262,110.952148 118.208496,113.089844 C121.44873,115.227539 117.765625,189.371094 116.598145,196.439453 C115.430664,203.507812 91.6591797,205.970703 90.4692383,197.858398 C89.2792969,189.746094 89.8383789,141.045898 99.1572266,113.089844 C97.6630859,112.420898 74.5185547,112.144531 72.2077521,112.420898 C70.9160156,122.145508 75.8193359,192.163086 72.2077521,197.858398 C68.2551635,204.091461 52.3173828,202.108398 49.6318359,197.858398 C46.9462891,193.608398 54.7407227,116.321777 56.3461914,113.874512 C57.9516602,111.427246 79.6150688,109.600586 86,109.600586 Z",
      "id": "hailey_top_2",
      "fill": "#5580B0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M107.633789,111.023438 C110.291016,111.023438 116.800781,111.023438 118.958984,113.246094 C105.429688,113.246094 107.633789,161.900391 107.000156,168.212402 C107.000156,170.068848 106.612013,176.603794 107.000156,178.789063 C97.6044922,159.733398 94.8818359,125.729492 107.633789,111.023438 Z",
      "id": "hailey_bag_2",
      "fill": "#4A4A4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M55.7568359,114.081055 C58.0975962,111.799837 60.1318359,110.765625 63.9658203,109.589844 C59.1689453,134.499023 51.9316406,155.834961 49.6914062,176.022461 C49.3388672,145.268555 53.9140625,115.876953 55.7568359,114.081055 Z",
      "id": "hailey_bag_1",
      "fill": "#4A4A4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M84.857276,97.71875 C109.613966,97.71875 109.489258,110.317383 107.48877,118.179199 C105.488281,126.041016 103.409668,132.370605 93.746582,137.218262 C94.5888672,128.882813 97.3071289,118.179199 98.8999023,112.923828 C96.2700195,112.923828 75.0083008,112.923828 72.3271484,112.923828 C71.809082,119.248599 72.3271484,127.730469 72.3271484,137.218262 C66.3032227,132.675781 62.8037109,128.115234 61.6694336,118.179199 C60.5351562,108.243164 60.1005859,97.71875 84.857276,97.71875 Z",
      "id": "hailey_top_1",
      "fill": "#6592C7"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "hailey_left_arm"
    }
  }, [_c('g', {
    attrs: {
      "id": "hailey_left_arm_hand"
    }
  }, [_c('path', {
    attrs: {
      "d": "M107.254033,237.02832 C107.234146,239.91794 105.279278,241.528917 103.388935,244.938653 C101.183372,248.916973 101.444156,256.045269 99,262.073143 C99.7068649,263.457744 103.921123,260.845795 104.778388,258.423881 C105.635654,256.001968 106.285621,254.033933 106.583198,253.421223 C106.880776,252.808513 107.622159,252.850588 107.848993,253.429112 C108.075827,254.007636 108.657705,275.043309 109.123512,276.074134 C109.589318,277.104959 112.166615,277.141599 112.6108,276.074134 C113.054985,275.006669 112.994673,258.363048 113.212214,257.917585 C113.429755,257.472121 113.996271,257.686526 114.235433,257.917585 C114.474595,258.148644 114.062083,275.927925 114.446904,276.589547 C114.831726,277.251168 117.493422,277.136515 117.781327,276.589547 C118.069231,276.042578 118.168044,258.319922 118.457466,257.917585 C118.746888,257.515247 119.333319,257.560302 119.573239,257.917585 C119.81316,258.274867 119.158452,275.340986 119.573239,276.074134 C119.988027,276.807282 122.568738,276.818853 122.806193,276.074134 C123.043648,275.329415 123.570525,258.166876 123.820498,257.917585 C124.070471,257.668293 124.406739,257.69161 124.644952,257.917585 C124.883166,258.14356 125.135225,270.962082 125.546978,271.658766 C125.958731,272.355449 127.911856,272.520066 128.19976,271.658766 C128.487665,270.797466 127.11098,239.549526 127.149313,237.815397 C127.277062,232.036295 123.898918,226 117.121268,226 C110.343618,226 107.29674,230.823102 107.254033,237.02832 Z",
      "id": "hailey_left_hand",
      "fill": "#DBBFAF"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M117,176 L117,176 L117,176 C122.522847,176 127,180.477153 127,186 L127,236 L107,236 L107,186 L107,186 C107,180.477153 111.477153,176 117,176 Z",
      "id": "hailey_left_arm_bottom",
      "fill": "#6592C7"
    }
  })]), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "hailey_left_arm_top",
      "fill": "#6592C7",
      "x": "107",
      "y": "113",
      "width": "20",
      "height": "83",
      "rx": "10"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M77.239385,100.912604 C78.0564605,106.172806 77.239385,112.74928 72.5371094,112.74928 C73.2148438,115.892578 76.6503906,121.379395 83.2856445,121.379395 C89.9208984,121.379395 97.3286133,118.272461 98.6787109,112.74928 C93.3803075,112.74928 92.124737,106.789986 93.3803075,100.912604 C91.8200709,96.6719335 79.4180506,96.8139199 77.239385,100.912604 Z",
      "id": "hailey_neck",
      "fill": "#CAA792"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "hailey_head"
    }
  }, [_c('path', {
    attrs: {
      "d": "M122.433968,64.3265126 C124.55982,63.0770623 127.611696,61.4898103 131.071884,64.3265126 C134.031578,66.7529052 131.806787,76.2719047 127.814276,81.5434966 C123.859603,86.7651271 117.426584,87.8492384 114.901538,85.8477426 C109.574298,97.847825 95.9974278,104.220127 86.9239385,104.140788 C62.6322991,103.928382 52.4899704,79.3566403 52.4899704,58.9462051 C52.4899704,26.7524258 65.3657664,15.9041718 86.9239385,15.9041718 C106.273712,15.7989634 127.751225,26.0180926 122.433968,64.3265126 Z",
      "id": "hailey_face",
      "fill": "#DBBFAF",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M120.281845,72.1304811 C122.207512,68.0923607 125.218172,64.3492639 128.890337,65.6741121 C132.562502,66.9989603 127.860513,81.8374964 118.129722,81.8150347 C119.255961,81.1200345 122.334401,77.8860404 122.433968,75.3586656 C122.533535,72.8312909 121.716638,71.5651285 120.281845,72.1304811 Z",
      "id": "hailey_ear",
      "fill": "#CAA792"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.989502,88.861084 C73.9158314,89.9182649 75.4786852,95.5545215 79.8807345,95.5545215 C84.2827838,95.5545215 90.1997867,89.3896744 89.8776855,88.861084 C89.5555844,88.3324935 83.9606827,92.2772608 79.8807345,92.2772608 C75.4786852,92.1715427 75.2408645,89.6966553 74.989502,88.861084 Z",
      "id": "hailey_mouth_open_bottom",
      "fill": "#DA52BB",
      "fill-rule": "nonzero",
      "opacity": "0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M75.0846228,89.22204 C76.7672119,89.6428737 86.2317752,89.7480822 89.3866297,89.1168316 C91.0692187,88.8012063 87.2833934,91.9574592 80.9736845,91.9574592 C74.6639756,91.9574592 75.0846228,89.22204 75.0846228,89.22204 Z",
      "id": "hailey_mouth_bottom",
      "fill": "#DA52BB",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M74.0330047,89.1168316 C74.0330047,87.749122 75.0846228,86.5918293 80.5530372,86.5918293 C84.3388625,86.5918293 90.4382478,88.485581 93.4879404,87.6439136 C94.1189113,87.4334967 94.1189113,87.9595389 93.2776168,88.2751642 C89.3866297,89.6428737 85.6008043,89.6428737 79.8169045,89.6428737 C76.0310792,89.5376653 74.0330047,89.1168316 74.0330047,89.1168316 Z",
      "id": "hailey_mouth_top",
      "fill": "#C63CA7",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78.3714038,62.3920657 C78.3714038,60.3145524 83.7172962,60.1324942 83.7199233,62.3920657 C83.7225504,64.6516372 85.4390997,76.4420767 83.7225504,78.5371916 C82.0060012,80.6323064 76.9599925,79.9303444 76.1790861,78.5371916 C75.3981797,77.1440387 75.5454288,74.8721198 77.239385,74.2392506 C78.9333412,73.6063814 78.3714038,64.469579 78.3714038,62.3920657 Z",
      "id": "hailey_nose",
      "fill": "#CAA792"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "hailey_left_cheek",
      "fill": "#DBB7A7",
      "cx": "103.064861",
      "cy": "80.6195581",
      "r": "6.45636901"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "hailey_right_cheek",
      "fill": "#DBB7A7",
      "cx": "66.47877",
      "cy": "80.6195581",
      "r": "6.45636901"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.304246,65.7963991 C95.1194499,58.0306901 107.639699,56.8455131 109.52123,63.5702684 C109.530162,72.6508329 94.3507595,73.4528637 92.304246,65.7963991 Z",
      "id": "hailey_left_eye_whites",
      "fill": "#FFFFFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "hailey_left_pupil",
      "fill": "#3C2D20",
      "cx": "103.064861",
      "cy": "65.6307586",
      "r": "4.30424601"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.304246,65.7963991 C95.1194499,58.0306901 107.639699,56.8455131 109.52123,63.5702684 C109.530162,72.6508329 94.3507595,73.4528637 92.304246,65.7963991 Z",
      "id": "hailey_left_eye_lids",
      "fill": "#C99374",
      "opacity": "0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M75.0872659,65.7963991 C72.272062,58.0306901 59.7518133,56.8455131 57.8702819,63.5702684 C57.8613497,72.6508329 73.0407525,73.4528637 75.0872659,65.7963991 Z",
      "id": "hailey_right_eye_whites",
      "fill": "#FFFFFF"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "hailey_right_pupil",
      "fill": "#3C2D20",
      "cx": "68.630893",
      "cy": "65.6307586",
      "r": "4.30424601"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M75.0872659,65.7963991 C72.272062,58.0306901 59.7518133,56.8455131 57.8702819,63.5702684 C57.8613497,72.6508329 73.0407525,73.4528637 75.0872659,65.7963991 Z",
      "id": "hailey_right_eye_lids",
      "fill": "#C99374",
      "opacity": "0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M92.3241444,51.7456197 C94.4788319,50.5780908 105.818512,50.3795912 108.30483,51.7456197 C110.791148,53.1116481 108.970692,54.457544 107.239451,53.9263991 C105.50821,53.3952541 95.2284467,53.2865867 93.3895234,53.9263991 C91.5506001,54.5662114 90.1694569,52.9131486 92.3241444,51.7456197 Z",
      "id": "hailey_left_brow",
      "fill": "#3C2D20"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M73.9913021,51.7456197 C71.8366146,50.5780908 60.4969344,50.3795912 58.0106165,51.7456197 C55.5242985,53.1116481 57.3447546,54.457544 59.0759955,53.9263991 C60.8072364,53.3952541 71.0869998,53.2865867 72.9259231,53.9263991 C74.7648464,54.5662114 76.1459896,52.9131486 73.9913021,51.7456197 Z",
      "id": "hailey_right_brow",
      "fill": "#C08522"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M69.1416016,29.5537109 C74.8837891,52.0556641 89.6933594,54.4287109 106.072266,58.6025391 C122.451172,62.7763672 111.389648,82.46875 104.954102,90.9228516 C113.112305,87.7099609 126.075127,79.2507721 126.447266,64.8740234 C126.947266,45.5576172 129.415527,15.0107422 91.9726562,14.925293 C54.5297852,14.8398437 51.8271484,37.2783203 52.0039063,62.8554688 C54.1152344,53.1777344 58.8173828,39.5449219 69.1416016,29.5537109 Z",
      "id": "hailey_bangs",
      "fill": "#DD9B2E"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f782fa4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_3/svg/hailey.vue
// module id = 762
// module chunks = 1